import React from 'react';
import CleanerCoopLogo from '../../Images/CoopDashboard.png'
import '../../CSS/foundation_css/_logo.css';
import '../../CSS/dashboard.css';
import { Link } from 'react-router-dom'


const DashboardCleanerLogo = (props) => {
    return (
      <div>
        <Link to="/CleanersDashboardHome"><img src={CleanerCoopLogo} alt="" className="coop-logo-dashboard" /></Link>
      </div>
    )
  }
  export default DashboardCleanerLogo;